import React from 'react';

class ProfitWellComponent extends React.Component {
  state = {
    hasInit: false
  }
  componentDidUpdate() {
    const { profitwell } = window;
    const { hasInit } = this.state;
    if (!profitwell || hasInit) return;
    const { email } = this.props;
    if (email) {
      profitwell('start', { 'user_email': email });
      this.setState({
        hasInit: true
      })
    }
  }

  render() {
    return null;
  }
}

export default ProfitWellComponent;


// WEBPACK FOOTER //
// ./src/components/ProfitWellComponent/ProfitWellComponent.js